<template>
    <div id="zip-insight-panel" v-if="selectedZipLatLng">
        <div>
            Showing
            <em>{{ selectedStatistic.label }}</em>
            in year <em>{{ queryYear }}</em>
            for five transplant centers closest to you.
        </div>
        <div class="list">
            <div
                    class="item"
                    v-for="(txCenter, index) in txValues"
                    :key="index">
                <div class="tx-name">
                    {{ txCenter.name }}:
                    <span class="tx-stat"><em>{{ txCenter['value'] }}</em></span>
                </div>
                <div class="tx-distance">
                    {{ Math.round(txCenter.distance * 0.00062137) }} miles away
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import statFun from '../api/txc'
import { mapGetters } from 'vuex'

export default {
  name: 'ZipInsightPanel',

  computed: {
    ...mapGetters({
      google: 'google',
      queryOrganMode: 'queryOrganMode',
      queryRegionMode: 'queryRegionMode',
      queryStatisticId: 'queryStatisticId',
      queryStatisticSubId: 'queryStatisticSubId',
      queryYear: 'queryYear',
      selectedStatistic: 'selectedStatistic',
      selectedZip: 'selectedZip',
      selectedZipClosestTxCenters: 'selectedZipClosestTxCenters',
      selectedZipLatLng: 'selectedZipLatLng',
      txCenters: 'txCenters',
      txRecords: 'txRecords'
    })
  },

  data: function () {
    return {
      txValues: []
    }
  },

  methods: {
    computeList: function () {
      // Copy array
      this.txValues = this.selectedZipClosestTxCenters.slice()

      // Calculate statistic value for selectedZipClosestTxCenters
      let query = {
        organMode: this.queryOrganMode,
        regionMode: this.queryRegionMode,
        year: this.queryYear
      }
      let selectedStatistic = this.selectedStatistic
      let txRecords = this.txRecords
      let statId = 'tx_stat_' + this.selectedStatistic.value
      this.selectedZipClosestTxCenters.forEach(function (txCenter) {
        let txId = txCenter.tx_ctr_id
        let txData = statFun[statId](txRecords, query, txId)
        let yearIndex = txData.years.indexOf(query.year)
        if (isNaN(txData.hist[yearIndex])) {
          txCenter['value'] = 'n/a'
          txCenter['value_numeric'] = -1
        } else if (selectedStatistic.legend === 'percent') {
          txCenter['value'] = Math.round(100 * txData.hist[yearIndex]) + '%'
          txCenter['value_numeric'] = txData.hist[yearIndex]
        } else {
          let precision = selectedStatistic.unit_precision || 1
          let statUnit = this.allLegends[selectedStatistic.legend].unit
          txCenter['value'] = Math.round(precision * txData.hist[yearIndex]) / precision + ' ' + statUnit
          txCenter['value_numeric'] = txData.hist[yearIndex]
        }
      })

      // Sort by value
      this.txValues.sort(function (a, b) {
        return b.value_numeric - a.value_numeric
      })

      // Get closest 5 centers with values != n/a
      // this.txValues = this.txValues.filter(function (a) {
      //   return a.value_numeric >= 0
      // }).slice(0, 5)
    }
  },

  mounted: function () {
    this.computeList()
  },

  watch: {
    queryOrganMode: 'computeList',
    queryRegionMode: 'computeList',
    queryStatisticId: 'computeList',
    queryStatisticSubId: 'computeList',
    queryYear: 'computeList',
    selectedZipClosestTxCenters: 'computeList'
  }
}
</script>

<style scoped>
#zip-insight-panel {
    background-color: #25826a;
    color: #fff;
    position: absolute;
    left: 0;
    right: 0;
    padding: .5rem;
    z-index: 9999;
}

.item {
    margin-top: 1rem;
}

.tx-distance {
    color: #d3e6e1;
    font-size: .9rem;
}
</style>



// WEBPACK FOOTER //
// src/components/ZipInsightPanel.vue